export default __webpack_public_path__ + "static/18-a8b005ac0afce5172f80a0b0c96dabb4.jpg";